var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useWallet } from '@solana/wallet-adapter-react';
import { Menu, Modal } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { useWalletModal } from './useWalletModal';
import { WalletMenuItem } from './WalletMenuItem';
export const WalletModal = (_a) => {
    var { title = 'Select your wallet', featuredWallets = 3, onCancel } = _a, props = __rest(_a, ["title", "featuredWallets", "onCancel"]);
    const { wallets, select } = useWallet();
    const { visible, setVisible } = useWalletModal();
    const [expanded, setExpanded] = useState(false);
    const [featured, more] = useMemo(() => [wallets.slice(0, featuredWallets), wallets.slice(featuredWallets)], [wallets, featuredWallets]);
    const handleCancel = useCallback((event) => {
        if (onCancel)
            onCancel(event);
        if (!event.defaultPrevented)
            setVisible(false);
    }, [onCancel, setVisible]);
    const handleWalletClick = useCallback((event, walletName) => {
        select(walletName);
        handleCancel(event);
    }, [select, handleCancel]);
    const onOpenChange = useCallback(() => setExpanded(!expanded), [setExpanded, expanded]);
    return (React.createElement(Modal, Object.assign({ title: title, visible: visible, centered: true, onCancel: handleCancel, footer: null, width: 320, bodyStyle: { padding: 0 } }, props),
        React.createElement(Menu, { className: "wallet-adapter-modal-menu", inlineIndent: 0, mode: "inline", onOpenChange: onOpenChange },
            featured.map((wallet) => (React.createElement(WalletMenuItem, { key: wallet.name, onClick: (event) => handleWalletClick(event, wallet.name), wallet: wallet }))),
            more.length ? (React.createElement(Menu.SubMenu, { key: "wallet-adapter-modal-submenu", title: `${expanded ? 'Less' : 'More'} options` }, more.map((wallet) => (React.createElement(WalletMenuItem, { key: wallet.name, onClick: (event) => handleWalletClick(event, wallet.name), wallet: wallet }))))) : null)));
};
//# sourceMappingURL=WalletModal.js.map